import { render } from "./GameVoteView.vue?vue&type=template&id=53b603e7"
import script from "./GameVoteView.vue?vue&type=script&lang=js"
export * from "./GameVoteView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__